import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { DATASourceDataTables, DataTables } from "../../../Constant";
import HtmlSourcedData from "./HtmlSourcedData";
import AjaxSourcedData from "./AjaxSourcedData";
import JavaScriptSourcedData from "./JavaScriptSourcedData";
import ServerSideProcessing from "./ServerSideProcessing";

const DataSourceContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={DATASourceDataTables} parent={DataTables} title={DATASourceDataTables} />
      <Container fluid>
        <Row>
          <HtmlSourcedData />
          <AjaxSourcedData />
          <JavaScriptSourcedData/>
          <ServerSideProcessing/>
        </Row>
      </Container>
    </>
  );
};

export default DataSourceContainer;
